import { APP_CONFIG } from 'app-config';

export const DEFAULT_PAGINATION_PARAMS = {
	pageNumber: APP_CONFIG.TABLE_DEFAULT_PAGINATION_PAGE,
	pageSize: APP_CONFIG.TABLE_PAGE_SIZE
};
